<template>
  <div style="width: 1200px;margin: 20px auto;background: #FFFFFF;padding-top: 10px;">
    <a-form style="margin-left: 15px" layout="inline" @keyup.enter.native="searchQuery">
      <a-form-item label="合同标题">
        <a-input placeholder="请输入合同标题" v-model="queryParam.title"></a-input>
      </a-form-item>
      <a-button type="primary" style="background: #d7000f;border: #d7000f" @click="searchQuery" icon="search">查询</a-button>
      <a-button type="primary" @click="searchReset" icon="reload" style="margin-left: 8px;background: #d7000f;border: #d7000f">重置</a-button>
    </a-form>
    <a-table
        :columns="columns"
        :data-source="dataSource"
        :pagination="ipagination"
        :loading="loading"
        rowKey="contractId"
        :customRow="rowClick"
        @change="handleTableChange">
<!--        <a-tooltip slot="tool"  slot-scope="text, record">-->
<!--          <template slot="title">{{record.des}}</template>-->
<!--          {{text}}-->
<!--        </a-tooltip>-->
        <template slot="toDetails" slot-scope="text, record">
          <router-link :to="{path:`/contractDetails/${record.contractId}`}">
            <span style="color: #606266">{{record.title}}</span>
          </router-link>
        </template>
        <span slot="action" slot-scope="text, record">
          <a @click="deatils(record.contractId)">详情</a>
        </span>
    </a-table>
  </div>

</template>

<script>
import {getAction} from "@/api/manage";
export default {
  name: "ContractList",
  data() {
    return {
      dataSource: [],
      columns: [
        {
          title: '合同标题',
          dataIndex: 'title',
          width: '35%',
          scopedSlots: { customRender: 'toDetails' }
        },
        {
          title: '发布编号',
          dataIndex: 'number',
          width: '30%',
          // scopedSlots: { customRender: 'tool' },
        },
        {
          title: '发布机关',
          dataIndex: 'organ',
          width: '35%',
          // scopedSlots: { customRender: 'tool' },
        },
        // {
        //   title: '合同简介',
        //   dataIndex: 'des',
        //   ellipsis: true
        // },
        // {
        //   title: '操作',
        //   dataIndex: 'action',
        //   align: "center",
        //   width: 80,
        //   scopedSlots: {customRender: 'action'},
        // }
      ],
      ipagination: {
        current: 1,
        pageSize: 10,
        pageSizeOptions: ['10', '30', '50'],
        showTotal: (total, range) => {
          return "第" + range[0] + "至" + range[1] + "条,共" + total + "条"
        },
        showQuickJumper: true,
        showSizeChanger: true,
        total: 0
      },
      loading: false,
      queryParam: {},
      isorter:{
        column: 'createTime',
        order: 'desc',
      },
      /* 筛选参数 */
      filters: {},
    }
  },
  created() {
    this.dataList()
  },
  methods: {
    rowClick(record){
      return {
        on: {
          mouseenter: () => {
            return ' '
          },
          mouseleave: () => {
            console.log('鼠标移出')
          }
        }
      }
    },
    searchQuery(){
      this.dataList(1);
    },
    searchReset() {
      this.queryParam = {}
      this.dataList();
    },
    getQueryParams() {
      //获取查询条件
      let sqp = {}
      var param = Object.assign(sqp, this.queryParam, this.isorter ,this.filters);
      param.field = this.getQueryField();
      param.pageNo = this.ipagination.current;
      param.pageSize = this.ipagination.pageSize;
      return param;
    },
    getQueryField() {
      //TODO 字段权限控制
      var str = "id,";
      this.columns.forEach(function (value) {
        str += "," + value.dataIndex;
      });
      return str;
    },
    deatils(id){
      this.$router.push(`/contractDetails/${id}`);
    },
    dataList(arg) {
      if (arg === 1) {
        this.ipagination.current = 1;
      }
      var param = this.getQueryParams();
      this.loading = true;
      getAction('/contract/pageList', param).then(res => {
        if (res.success) {
          this.loading = false;
          this.dataSource = res.data.records;
          this.ipagination.total = res.data.total;
        }
      })
    },
    handleTableChange(pagination, filters, sorter) {
      if (Object.keys(sorter).length > 0) {
        this.isorter.column = sorter.field;
        this.isorter.order = "ascend" == sorter.order ? "asc" : "desc"
      }
      this.ipagination = pagination;
      this.dataList();
    },
  }
}
</script>

<style scoped>

</style>
